<template>
  <div id="categories">
    <categories-add-new
      :is-add-new-sidebar-active.sync="isAddNewSidebarActive"
      :category-types="categoryTypes"
      :category-statuses="categoryStatuses"
      @refetch-data="refetchData"
    />

    <b-card class="mb-0" body-class="p-0">
      <div class="m-2">
        <b-row>
          <b-col
            cols="6"
            md="2"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Type -->
          <b-col cols="6" md="4">
            <v-select :options="categoryTypes" :clearable="true" v-model="categoryType" />
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button variant="primary" @click="isAddNewSidebarActive = true">
                <span class="text-nowrap">Add New Category</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- 
        Categories Table
       -->
      <b-table
        ref="refCategoriesTable"
        class="position-relative"
        :items="fetchCategories"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="isLoading ? 'Loading...' : 'No matching records found'"
      >
        <template #cell(name)="data">
          {{ data.item.name }}
        </template>
        <template #cell(slug)="data">
          {{ data.item.slug }}
        </template>
        <template #cell(type)="data">
          {{ data.item.type }}
        </template>
        <template #cell(displayOrder)="data">
          <b-form-spinbutton
            v-model="data.item.displayOrder"
            @change="changeDisplayOrder(data.item._id, $event)"
          ></b-form-spinbutton>
        </template>
        <template #cell(isActive)="data">
          <b-badge :variant="`light-${resolveCategoryStatusVariant(data.item.isActive)}`">{{
            data.item.isActive ? "Active" : "Disabled"
          }}</b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-button :data-test="data.item._id" size="sm" variant="warning">Edit</b-button>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalCategories"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormSpinbutton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import useCategoriesList from "./useCategoriesList";
import CategoriesAddNew from "./CategoriesAddNew";
import { ref, onUnmounted } from "@vue/composition-api";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormSpinbutton,
    CategoriesAddNew,

    vSelect,
  },

  setup() {
    const isAddNewSidebarActive = ref(false);

    const {
      perPage,
      perPageOptions,
      searchQuery,
      fetchCategories,
      tableColumns,
      resolveCategoryStatusVariant,
      refCategoriesTable,
      totalCategories,
      currentPage,
      dataMeta,
      categoryTypes,
      categoryType,
      changeDisplayOrder,
      categoryStatuses,
      refetchData,
      isLoading,
    } = useCategoriesList();

    return {
      perPage,
      perPageOptions,
      totalCategories,
      searchQuery,
      fetchCategories,
      tableColumns,
      resolveCategoryStatusVariant,
      refCategoriesTable,
      totalCategories,
      currentPage,
      dataMeta,
      categoryTypes,
      categoryType,
      changeDisplayOrder,
      isAddNewSidebarActive,
      categoryStatuses,
      refetchData,
      isLoading,
    };
  },
};
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
